import { inject, Injectable, Injector, runInInjectionContext } from '@angular/core';

@Injectable({
	providedIn: 'root'
})
export class AngularFireContextService {
	private readonly injector = inject(Injector);

	public run<T>(operation: () => T): T {
		return runInInjectionContext(this.injector, operation);
	}
}
